import React from 'react'
import ShopNow from '../../components /ProductPage/ShopNow'

const shopNowPage = () => {
  return (
    <div>
      <ShopNow />
    </div>
  )
}

export default shopNowPage
